import React from 'react'
const h2class = "text-4xl mb-4";

export default function SectionTitle({children, className}) {
  return (
  <h2 className={`${h2class} ${className}`}>{children}</h2>
  )
}
